export enum ChatLinksDataAnalytics {
  telegram = 'telegram',
  ok = 'ok.ru',
  vk = 'vk.com',
  viber = 'viber',
  whatsapp = 'whatsapp',
  call = 'tel:',
}
